import { render, staticRenderFns } from "./TeacherProducts.vue?vue&type=template&id=03743555"
import script from "./TeacherProducts.vue?vue&type=script&lang=js"
export * from "./TeacherProducts.vue?vue&type=script&lang=js"
import style0 from "./TeacherProducts.vue?vue&type=style&index=0&id=03743555&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports